// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file subscription/v1/shopify_plan.proto (package subscription.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Addon } from './addon_pb';
import { file_subscription_v1_addon } from './addon_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file subscription/v1/shopify_plan.proto.
 */
export const file_subscription_v1_shopify_plan: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiJzdWJzY3JpcHRpb24vdjEvc2hvcGlmeV9wbGFuLnByb3RvEg9zdWJzY3JpcHRpb24udjEiRQoLU2hvcGlmeVBsYW4SDgoGaGFuZGxlGAEgASgJEiYKBmFkZG9ucxgCIAMoCzIWLnN1YnNjcmlwdGlvbi52MS5BZGRvbkKKAQoTY29tLnN1YnNjcmlwdGlvbi52MUIQU2hvcGlmeVBsYW5Qcm90b1ABWgQuL3BiogIDU1hYqgIPU3Vic2NyaXB0aW9uLlYxygIPU3Vic2NyaXB0aW9uXFYx4gIbU3Vic2NyaXB0aW9uXFYxXEdQQk1ldGFkYXRh6gIQU3Vic2NyaXB0aW9uOjpWMWIGcHJvdG8z',
        [file_subscription_v1_addon]
    );

/**
 * @generated from message subscription.v1.ShopifyPlan
 */
export type ShopifyPlan = Message<'subscription.v1.ShopifyPlan'> & {
    /**
     * @generated from field: string handle = 1;
     */
    handle: string;

    /**
     * @generated from field: repeated subscription.v1.Addon addons = 2;
     */
    addons: Addon[];
};

/**
 * Describes the message subscription.v1.ShopifyPlan.
 * Use `create(ShopifyPlanSchema)` to create a new message.
 */
export const ShopifyPlanSchema: GenMessage<ShopifyPlan> =
    /*@__PURE__*/
    messageDesc(file_subscription_v1_shopify_plan, 0);
